<template>
    <v-card @click="goToPage" :style="[toPage ? {'cursor': 'pointer', 'border-radius': '8px'} : {'border-radius': '8px'}]">
        <v-sheet :color="color" class="layout row justify-center corner" elevation="1" style="border-radius: 8px">
            <v-icon color="white">{{icon}}</v-icon>
        </v-sheet>
        <v-card-title>
            <div class="layout column ma-0 justify-space-between pb-1">
                <div class="title">{{title}}</div>
                <p v-if="description" class="description">{{ description }}</p>
            </div>
        </v-card-title>

        <v-card-text class="pt-1">
            <h3 class="headline">{{reachedAmount | fmtFixed}}<span class="caption ml-2">{{caption}}</span></h3>
            <!-- <v-progress-linear v-if="!hasCancelled && linearStatistic" :color="color" :value="percent * 100" class="mb-1" height="7"></v-progress-linear> -->
            <p v-if="!linearStatistic" class="user-today-balance-value" style="font-size: 15px;color: #60C232;line-height: 1; margin-top: 14px; margin-bottom: 4px;">+ {{ todayBalance | fmtFixed }} hoje </p>
            <div v-else>
                <div style="width: 100%; height: 7px; display: flex; flex-direction: row; background: #2962ff48; margin-top: 14px; margin-bottom: 4px;"> 
                    <div v-bind:key="line.id" v-for="line in lines" :style="{width: `${getPercent(line.value) * 100}%`}">
                        <div v-if="(getPercent(line.value) * 100).toFixed(1) > 0.1" :style="{width: '100%', backgroundColor: `${line.color}`, height: '100%'}"></div>
                    </div>
                </div>
                <div style="width: 100%; display: flex; flex-direction: row;">
                    <span v-bind:key="line.id" v-for="line in lines" :style="{ width: `${getPercent(line.value) * 100}%`, maxWidth: '94.5%'}" class="caption"><p v-if="(getPercent(line.value) * 100).toFixed(1) > 3">{{ getPercent(line.value) | fmtPercentP1 }}</p></span>
                </div>
            </div>
            <div v-if="linearStatistic" style="width: 100%; display: flex; justify-content: space-between; flex-direction: row; margin-top: 5px;">
                <div style="display: flex; flex-direction: row; align-items: center;">
                    <div style="display: flex; flex-direction: row; align-items: baseline; margin-right: 10px;" v-bind:key="line.id" v-for="line in lines">
                        <v-tooltip bottom>
                            <div slot="activator" style="display: flex; flex-direction: row; align-items: center; cursor: pointer;">
                                <div :style="{ width: '10px', height: '10px', backgroundColor: `${line.color}`, marginRight: '3px', borderRadius: '100%' }"></div>
                                <span class="caption" >{{ line.title }}</span>
                            </div>
                            {{ line.tooltip }}
                        </v-tooltip>
                    </div>
                </div>
                <span class="caption font-weight-bold">de {{total | fmtFixed}}</span>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        
        props: {
            icon: String,
            title: String,
            total: Number,
            cancelledAmount: Number,
            reachedAmount: Number,
            lines: Array,
            caption: String,
            color: String,
            description: String,
            linearStatistic: {
                type: Boolean,
                default: true
            },
            todayBalance: {
                type: Number,
                default: 0
            },
            toPage: String
        },

        methods: {
            goToPage() {
                if (this.toPage) {
                    this.$router.push(this.toPage);
                }
            },

            getPercent(value) {
                let p = 0;
                if (value > 0) {
                    p = value / this.total;
                }

                return p;
            },
        },
   };
</script>

<style scoped>
   .corner {
      margin-top: -7px !important;
      margin-right: -7px !important;
      height: 60px;
      width: 95px;
      float: right;
   }

   .description {
      font-size: 15px;
      margin-top: 5px;
      color: #555;
   }
</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/widgets/statistic/CardLinearStatistic.vue